
export class OutboundApi {
  /**
   * 表格查询参数
   *
   */
  static outboundFromRequest = {
    outboundOrderNo: '',
    lbxOrderCode: '',
    warehouseId: '',
    shopId: '',
    orderStatusId: '',
    platformId: '',
    cFromTime: '',
    cToTime: '',
    outboundReasonId: '',
    ids: '',
    pageSize: '',
    pageIndex: '',
    startTime: '',
    endTime: ''
  };

  /**
   * 表格标题
   *
   */

  static OutboundFromUrl = {

    queryWarehouseUrl: '/outboundOrder/queryWarehouse',

    queryOrderStatusUrl: '/outboundOrder/queryOrderStatus',
    queryOutboundReasonsUrl: '/outboundOrder/queryOutboundReasons',
    queryOutboundOrderUrl: '/outboundOrder/queryOutboundOrders',
    queryProcessNodes: '/outboundOrder/getPurchaseReturnOrderProcessNodeList',
    queryAegPurchaseOrderDetail: '/outboundOrder/queryAegReturnOrderDetail',

    downloadExcelTemplateUrl: '/inboundOrder/downloadExcelTemplate',

    queryLzdPurchaseOrderDetail: '/inboundOrder/queryLzdPurchaseOrderDetail',

    queryPurchaseOrderItemsUrl: '/inboundOrder/queryPurchaseOrderItems',

    queryConsignOrderUrl: '/inboundOrder/queryConsignOrder',
    queryLazadaProcessNodes: '/inboundOrder/queryOperateHistoryList'
  }
}



// WEBPACK FOOTER //
// ./src/js/OnboundApi.js